import Loader from 'components/Layout/Loader';
import Modal from 'components/Layout/Modal';
import PersonalDetails from 'pages/Register/MemberDetails/PersonalDetails';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchProfile } from 'store/slices';

const PreviewBasicInfoPopup = ({ onHide }) => {
  const [profileData, setProfileData] = useState({});
  const dispatch = useDispatch();
  const [loadData, setLoadData] = useState(false);

  const getProfiles = async () => {
    setLoadData(true);
    const response = await dispatch(fetchProfile());
    setProfileData(response?.data || {});
    setLoadData(false);
    return response;
  };

  useEffect(() => {
    getProfiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Modal
      titleBesideClose={`Basic Details`}
      titleBesideCloseClassName="text-16-400-20 color-1717"
      isTitleVerticalCenter
      isTitleBorder
      onHide={onHide}
    >
      {loadData ? (
        <div className="cp-20">
          <Loader size="md" />
        </div>
      ) : (
        <div className="cp-20">
          <PersonalDetails
            isEdit
            userDetails={profileData}
            fetchUserData={getProfiles}
            afterRedirect={() => {
              onHide();
            }}
            handelSuccess={() => {
              onHide();
            }}
            isBasicDetails
          />
        </div>
      )}
    </Modal>
  );
};

export default PreviewBasicInfoPopup;

// import React from 'react';
// import Modal from 'components/Layout/Modal';
// import { Formik } from 'formik';
// import * as Yup from 'yup';
// import TextInput from 'components/form/TextInput';
// import DatePicker from 'components/form/DatePicker';
// import Dropdown from 'components/form/Dropdown';
// import Location from 'components/form/Location';
// import {
//   convertString,
//   getDataFromLocalStorage,
//   numberOnlyFromInput,
//   titleCaseString,
// } from 'utils/helpers';
// import CreatableCityDropDown from 'components/form/CreatableCityDropDown';
// import Button from 'components/form/Button';

// const PreviewBasicInfoPopup = ({ onHide }) => {
//   const data = getDataFromLocalStorage();
//   const { date_of_birth, gender, country, state, city } =
//     data?.personal_details;

//   const { first_name, last_name, email_id, phone_number, country_code } = data;

//   const initialValues = {
//     first_name: first_name || '',
//     last_name: last_name || '',
//     email_id: email_id || '',
//     phone_number: phone_number || '',
//     date_of_birth: date_of_birth || '',
//     gender: gender || '',

//     country: country || '',
//     state: state || '',
//     country_name: '',
//     state_name: '',
//     city: city || '',
//     other_city: '',
//     country_code: country_code || '',
//   };

//   const validationSchema = Yup.object().shape({
//     first_name: Yup.string().required('First name is required.'),
//     last_name: Yup.string().required('Last name is required.'),
//     email_id: Yup.string()
//       .required('Email is required.')
//       .email('Email must be a valid email'),
//     phone_number: Yup.lazy((_, obj) => {
//       const { country_code, mobile_no_length } = obj?.parent || {};

//       if (country_code === 'IN' && mobile_no_length) {
//         const validLengths = Array.isArray(mobile_no_length)
//           ? mobile_no_length
//           : [mobile_no_length];
//         return Yup.string()
//           .required('Phone number is required.')
//           .test(
//             'valid-length',
//             `Phone number must be ${validLengths.join(' or ')} digits.`,
//             (value) => value && validLengths.includes(value.length)
//           );
//       } else {
//         return Yup.string()
//           .required('Phone number is required.')
//           .min(8, 'Phone number must be at least 8 digits.')
//           .max(15, 'Phone number must be at most 15 digits.');
//       }
//     }),
//     date_of_birth: Yup.string().required('Date of birth is required.'),
//     gender: Yup.string().required('Gender is required.'),
//     country: Yup.string().required('Country is required.'),
//     state: Yup.string().required('State/Province is required.'),
//     professional_institution_name: Yup.string().required(
//       'Institution Name is required.'
//     ),
//     professional_department: Yup.string().required(
//       'Institution Departments is required.'
//     ),
//     // address: Yup.string()
//     //   .required("Door no. and street name is required.")
//     //   .max(50, "Address is too long, it must be under 50 character."),
//     city: Yup.string().required('City is required.'),
//     other_city: Yup.lazy((_, o) => {
//       const { city } = o?.parent;
//       if (city === '586') {
//         return Yup.string().required('Please enter Other city name.');
//       } else {
//         return Yup.string();
//       }
//     }),
//   });

//   const handelSave = (values) => {
//     console.log('dddd', values);
//   };
//   return (
//     <Modal
//       titleBesideClose={`Basic Details`}
//       titleBesideCloseClassName="text-16-400-20 color-1717"
//       isTitleVerticalCenter
//       isTitleBorder
//       onHide={onHide}
//     >
//       <Formik
//         enableReinitialize
//         initialValues={initialValues}
//         validationSchema={validationSchema}
//         onSubmit={(values) => {
//           handelSave(values);
//         }}
//       >
//         {(props) => {
//           const {
//             values,
//             errors,
//             handleChange,
//             setFieldValue,
//             handleSubmit,
//             // resetForm,
//           } = props;

//           return (
//             <form>
//               <div className="cp-20">
//                 <div className="row">
//                   <div className="col-md-4 cmb-22">
//                     <TextInput
//                       placeholder="First Name"
//                       id="first_name"
//                       value={values.first_name}
//                       error={errors.first_name}
//                       //disabled={is_temp === '2' && !is_name_empty}
//                       onChange={(e) => {
//                         setFieldValue(
//                           'first_name',
//                           titleCaseString(e.target.value)
//                         );
//                       }}
//                     />
//                   </div>
//                   <div className="col-md-4 cmb-22">
//                     <TextInput
//                       placeholder="Last Name"
//                       id="last_name"
//                       value={values.last_name}
//                       //disabled={is_temp === '2' && !is_name_empty}
//                       error={errors.last_name}
//                       onChange={(e) => {
//                         setFieldValue(
//                           'last_name',
//                           titleCaseString(e.target.value)
//                         );
//                       }}
//                     />
//                   </div>
//                   <div className="col-md-4 cmb-22">
//                     <TextInput
//                       isPhoneNumber
//                       type="number"
//                       placeholder="Phone Number"
//                       id="phone_number"
//                       //disabled={phone_number}
//                       value={values.phone_number}
//                       error={errors.phone_number}
//                       phoneNumberData={{
//                         id: 'country_code',
//                         value: values.country_code,
//                       }}
//                       onChange={(e) => {
//                         if (e.target.id === 'phone_number') {
//                           handleChange(numberOnlyFromInput(e));
//                         } else {
//                           handleChange(e);
//                           handleChange({
//                             target: { id: 'phone_number', value: '' },
//                           });
//                           setFieldValue('mobile_no_length', e.target.length);
//                         }
//                       }}
//                     />
//                   </div>
//                   <div className="col-md-4 cmb-22">
//                     <TextInput
//                       placeholder="Email ID"
//                       id="email_id"
//                       // disabled
//                       value={values.email_id}
//                       onChange={(e) => {
//                         handleChange(convertString(1, e));
//                       }}
//                       error={errors.email_id}
//                     />
//                   </div>
//                   <div className="col-md-4 cmb-22">
//                     <DatePicker
//                       placeholder="Date of Birth"
//                       id="date_of_birth"
//                       value={values.date_of_birth}
//                       onChange={handleChange}
//                       error={errors.date_of_birth}
//                       maxDate={new Date()}
//                     />
//                   </div>
//                   <div className="col-md-4 cmb-22">
//                     <Dropdown
//                       placeholder="Gender"
//                       options={[
//                         { id: 'Male', label: 'Male' },
//                         { id: 'Female', label: 'Female' },
//                       ]}
//                       id="gender"
//                       value={values.gender}
//                       onChange={handleChange}
//                       error={errors.gender}
//                     />
//                   </div>
//                   <div className="col-md-4 cmb-22">
//                     <Location
//                       type="country"
//                       data={{
//                         id: 'country',
//                         placeholder: 'Country',
//                         value: values.country,
//                         error: errors.country,
//                         onChange: (e) => {
//                           setFieldValue(
//                             'country_name',
//                             e?.target?.data?.country
//                           );
//                           handleChange(e);
//                         },
//                       }}
//                     />
//                   </div>
//                   <div className="col-md-4 cmb-22">
//                     <Location
//                       type="state"
//                       data={{
//                         id: 'state',
//                         placeholder: 'State/Province',
//                         value: values.state,
//                         error: errors.state,
//                         countryId: values.country,
//                         disabled: !values.country,
//                         onChange: (e) => {
//                           setFieldValue('state_name', e?.target?.data?.state);
//                           handleChange(e);
//                         },
//                       }}
//                     />
//                   </div>

//                   <div className="col-md-4 cmb-22">
//                     <CreatableCityDropDown
//                       id="city"
//                       disabled={!values?.state}
//                       onChange={(e) => {
//                         handleChange(e);
//                       }}
//                       value={values?.city}
//                       error={errors?.city}
//                       countryId={values?.country_name}
//                       stateId={values?.state_name}
//                       isClearable
//                     />
//                   </div>
//                   {+values?.city === 586 && (
//                     <div className="col-md-4 cmb-22">
//                       <TextInput
//                         placeholder="Add Other City"
//                         id="other_city"
//                         value={values.other_city}
//                         error={errors.other_city}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   )}
//                 </div>

//                 <div className="d-flex justify-content-start mt-3 gap-3">
//                   <Button
//                     text="Submit"
//                     btnStyle="primary-dark"
//                     className="cps-26 cpe-26 cpt-15 cpb-15 h-40"
//                     onClick={handleSubmit}
//                     // btnLoading={btnLoading}
//                   />

//                   <Button
//                     text="Cancel"
//                     btnStyle="primary-outline1"
//                     className="text-14-500 cps-20 cpe-20 h-40"
//                     onClick={onHide}
//                   />
//                 </div>
//               </div>
//             </form>
//           );
//         }}
//       </Formik>
//     </Modal>
//   );
// };

// export default PreviewBasicInfoPopup;
